import { render, staticRenderFns } from "./BaseTimesCircleIcon.vue?vue&type=template&id=30c40360"
import script from "./BaseTimesCircleIcon.vue?vue&type=script&lang=js"
export * from "./BaseTimesCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports